/**************************************************
 * Nombre:       Lista_Recomendaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Articulos from "../../../Tarjetas/Tarjeta_Articulos";

const Lista_Recomendaciones = ({items}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={6}
        >

            {items.map((it) => (
                <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Articulos item={it}/>
                </Grid>
            ))}

        </Grid>
    )

}
export default Lista_Recomendaciones

